import cc from "classcat";

const HorizontalDivider = ({ dashed = false, className = "", ...props }) => (
  <div
    className={cc([
      "h-divider",
      className,
      { dashed: dashed, "my-md-15 my-6": !className.match(/m[y]-\d+/) },
    ])}
    {...props}
  />
);

export default HorizontalDivider;
